import React from "react";
import {
    Grid,
    Paper,
    Collapse,
    Skeleton
} from "@mui/material";
import ForecastDropdown from "./ForecastDropdown";
import ForecastPeriodDropdown from "./ForecastPeriodDropdown";

interface Forecast {
    forecastId: number;
    name: string;
    startPeriod: string;
    forecastPeriods: ForecastPeriod[];
}

interface ForecastPeriod {
    forecastPeriodId: number;
    name: string;
    periodIndex: number;
    isLocked: boolean;
}

interface CompareFiltersProps {
    compareExpanded: boolean;
    forecasts: Forecast[];
    loadingForecasts: boolean;
    compareForecastId: number | null;
    compareForecastPeriodId: number | null;
    onCompareForecastSelected: (id: number | null) => void;
    onCompareForecastPeriodSelected: (forecastPeriodId: number | null) => void;
}

const CompareFilters: React.FC<CompareFiltersProps> = ({ 
    compareExpanded,
    forecasts,
    loadingForecasts,
    compareForecastId,
    compareForecastPeriodId,
    onCompareForecastSelected,
    onCompareForecastPeriodSelected
}) => {
    const compareForecast = forecasts.find((f) => f.forecastId === compareForecastId);

    return (
        <Collapse in={compareExpanded}>
            <Paper elevation={1} sx={{ p: 3, mb: 2 }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} sm="auto">
                        {loadingForecasts ? (
                            <Skeleton variant="rectangular" width={200} height={56} />
                        ) : (
                            <ForecastDropdown
                                forecasts={forecasts}
                                selectedForecastId={compareForecastId}
                                onForecastSelected={(id: number | null, period: string | null) => onCompareForecastSelected(id)}
                                width={200}
                            />
                        )}
                    </Grid>
                    <Grid item xs={12} sm="auto">
                        {loadingForecasts ? (
                            <Skeleton variant="rectangular" width={200} height={56} />
                        ) : (
                            <ForecastPeriodDropdown
                                forecastPeriods={compareForecast ? compareForecast.forecastPeriods : []}
                                selectedForecastPeriodId={compareForecastPeriodId}
                                onForecastPeriodSelected={onCompareForecastPeriodSelected}
                                width={200}
                            />
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </Collapse>
    );
};

export default CompareFilters;
